import React from 'react';
import { Typography } from '@mui/material';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import { Granit } from 'src/services/granits';
import { ImageContainer, ImageNameContainer } from './styles';

type GranitCardProps = {
  granit: Granit;
  imageUrl: string;
  isSelected: boolean;
  hasStock: boolean;
  onClick: () => void;
};

export const GranitCard: React.FC<GranitCardProps> = ({
  granit,
  imageUrl,
  isSelected,
  hasStock,
  onClick,
}) => {
  return (
    <ImageContainer imageUrl={imageUrl} isSelected={isSelected} onClick={onClick}>
      {hasStock ? (
        <div
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            padding: '6px',
          }}
        >
          <Inventory2OutlinedIcon style={{ color: '#fff', fontSize: '20px' }} />
        </div>
      ) : null}
      <ImageNameContainer>
        <Typography
          variant="body2"
          color="#344054"
          style={{
            fontFamily: 'Open Sans',
            fontStyle: 'normal',
            fontWeight: 600,
            fontSize: '12px',
            padding: '8px',
          }}
        >
          {granit.name} {granit.eco ? '(Eco granit)' : ''}
        </Typography>
      </ImageNameContainer>
    </ImageContainer>
  );
};
